document.addEventListener('DOMContentLoaded', function () {
  new Swiper('[data-upsell-slider]', {
    slidesPerView: 4.65,
    spaceBetween: 8,
    draggable: true,
    loop: false,

    pagination: {
      el: '[data-upsell-progressbar]',
      type: 'progressbar',
    },

    navigation: {
      nextEl: '[data-upsell-nav-next]',
      prevEl: '[data-upsell-nav-prev]',
    },

    breakpoints: {
      768: {
        slidesPerView: 4.35
      },
      1024: {
        slidesPerView: 4
      },
    },
  });
});

